import { parseNumeric, postRequest } from '../../../shared/utils';
import { resolveRecipientsWithNpiManagerFallback } from './notificationRecipients';

export async function createMeStoppedIndustrializationNotification({
  row,
  screenGridId,
  createdBy,
  valueOptionsProfitCenter,
  configSchema,
}: any) { 
  const rowId = parseNumeric(row.id1);
  const pcnrId = parseNumeric(row.pf_lc);
  const pcnrLabel =
    valueOptionsProfitCenter.find((option: any) => option.value === pcnrId)?.label ?? String(pcnrId);

  if (rowId == null || pcnrId == null) return null;

  const userIds = await resolveRecipientsWithNpiManagerFallback({
    screenGridId,
    pcnrId,
    configSchema,
  });
  if (!userIds.length) return null;

  const id1 = String(rowId);

  const payload = {
    screen: 'NPI_STEERING',
    rowId,
    pkey: 'id1',
    schemaName: 'npi',
    tableName: 'sheet1',
    screenGridId,
    messageKey: 'npiSteering.me_stopped_industrialization_message',
    messageParams: {
      id1,
      pf_lc: pcnrLabel,
    },
    actionConfig: {
      allowAccept: false, 
      allowReject: false,
      allowDelete: true,
    },
  };

  const result = await postRequest('/api/notification/createNotification', {
    type: 'ME_STOPPED_INDUSTRIALIZATION',
    payload,
    createdBy,
    userIds,
    status: 'UNREAD',
    message: `Warning: Industrialization of part with NPI ID ${id1} stopped by ME. Alignment with ME needed. Profit Center: ${pcnrLabel}`,
  });

  return result;
}